<template>
  <div class="App">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>export default {}</script>

<style lang="stylus">
	.picker-items
		.picker-slot
			font-size 14px
</style>
<style>
  .App{
    background-color: #F8F8F8;
  }
</style>

